import { CURRENCIES, isAltCurrency, loanHasStages } from '@/app/schemas/loan-comparator/loan.schema'
import { type ILoanSubmission } from '@/app/endpoints/loanComparatorEndpoints'
import { LOAN_INFORMATION_TYPES } from '@/app/constants/loanTypes'

// Payload shape expected by LoanComparatorAPIController -> updateLoanFromParams
export function mapLoanForSubmission(loan: any): ILoanSubmission | null {
    if (!loan) return null

    const loanTypeId = loan.type_loan?.id || 1
    const hasStages = loanHasStages(loanTypeId)
    // Only the _alt fields carry the typed currency, and the backend is what converts them.
    const useAltCurrency = isAltCurrency(loan.selected_currency)
    const amount = loan.sum?.toString() || null
    const amountLeft = loan.sum_left?.toString() || null
    // From the API, sum/sum_left hold the conversion: resubmitting them would convert twice.
    const altAmount = (loan.sum_alt_currency ?? loan.sum)?.toString() || null
    const altAmountLeft = (loan.sum_left_alt_currency ?? loan.sum_left)?.toString() || null

    return {
        id: loan.id?.toString() || null,
        // Symfony reads $data['type']['value']
        type: {
            value: loanTypeId,
            label: loan.type_loan?.name || 'Prêt classique',
        },
        reimbursement_delay: !!(loan.time_offset && loan.time_offset > 0),
        delay_type: loan.partial_time_offset ? 'partial' : 'total',
        delay_month_duration: loan.time_offset || null,
        amount: useAltCurrency ? null : amount || '0',
        amount_left: useAltCurrency ? null : amountLeft,
        save_amount_left: loan.information_type === LOAN_INFORMATION_TYPES.SUM_LEFT,
        selected_currency: loan.selected_currency || CURRENCIES.EUR,
        amount_alt: useAltCurrency ? altAmount : null,
        amount_left_alt: useAltCurrency ? altAmountLeft : null,
        rate: loan.rate?.toFixed(2) || '0.00',
        duration: loan.period?.toString() || '0',
        duration_left: loan.month_left?.toString() || null,
        initial_duration: null,
        // All stages are sent including the last auto-calculated one (matching the Vue.js behaviour)
        stages: hasStages
            ? (loan.palier || []).map((p: any) => {
                  // Field names differ between the API (montant/duree) and the form (amount/month_duration)
                  const stageAmount = (p.montant ?? p.sum ?? p.amount ?? 0).toString()
                  // `||` on purpose: legacy CHF stages store 0 in sum_alt_currency and the amount in montant.
                  const altStageAmount = (p.sum_alt_currency || stageAmount).toString()

                  return {
                      amount: useAltCurrency ? null : stageAmount,
                      amount_alt: useAltCurrency ? altStageAmount : null,
                      month_duration: (p.duree ?? p.period ?? p.month_duration ?? 0).toString(),
                  }
              })
            : [],
    }
}
